import React from "react";
import ServiceHero from "../ServiceHero";
import Timeline from "../Timeline";
import BentoGrid from "../BentoGrid";
import FadeOnScroll from "../FadeOnScroll";

const websiteProcess = [
  { title: "Initial Consultation", content: <p>Understanding business needs.</p> },
  { title: "Planning & Wireframing", content: <p>Creating and prototyping your website, piecing it together in an interactive, collaborative setting.</p> },
  { title: "Design & Development", content: <p>Beginning the development phase; touching up styling, colours and other features.</p> },
  { title: "Testing & Debugging", content: <p>Ensuring flawless performance.</p> },
  { title: "Deployment", content: <p>Launching your website smoothly.</p> },
  { title: "Ongoing Support", content: <p>Continuous updates and maintenance.</p> },
];

const websiteFeatures = [
  { title: "Responsive Design", description: "Catered to any device, based around your user base.", image: "/assets/responsive-design.png", className: "col-span-1 lg:col-span-4 border-b lg:border-r" },
  { title: "SEO Optimisation", description: "Boost your search rankings and go global.", image: "/assets/seo-websites.png", className: "col-span-1 lg:col-span-2 border-b" },
  { title: "Fast Performance", description: "Gain an in-depth and regularly updated insight on performance metrics and how this affects your business.", image: "/assets/secure-hosting.png", className: "col-span-1 lg:col-span-3 lg:border-r" },
  { title: "Secure & Reliable", description: "Providing you with a safe and secure website.", image: "/assets/maintenance-support.png", className: "col-span-1 lg:col-span-3 border-b" },
];

const Websites = () => {
  return (
    <div className="w-full bg-[#f5f3eb] dark:bg-[#1c1c1c] min-h-screen">
      
      {/* Hero Section */}
      <FadeOnScroll>
        <ServiceHero 
          title="Build Stunning Websites with Us"
          description="From concept to completion, we create modern, responsive websites."
          imageSrc="/assets/websites-hero.png"
          lightCircleColor="#E5A663"
          darkCircleColor="#F28444"
        />
      </FadeOnScroll>

      {/* Timeline Section */}
      <FadeOnScroll>
        <Timeline 
          title="Website Development Process"
          description="Our structured approach ensures a seamless journey from ideation to a fully functional website."
          data={websiteProcess} 
        />
      </FadeOnScroll>

      {/* What We Offer Section */}
      <FadeOnScroll>
        <div className="relative z-20 py-10 lg:py-40 max-w-7xl mx-auto">
          <div className="px-8">
            <h4 className="text-3xl lg:text-5xl text-center font-medium text-black dark:text-white">
              What We Offer
            </h4>
          </div>
          <BentoGrid features={websiteFeatures} />
        </div>
      </FadeOnScroll>
      
    </div>
  );
};

export default Websites;





